import { AGENCY_PHONE, REUNION_PHONE } from '@/lib/constants/agency'

export function useAgencyPhone() {
  return isReunionTimezone() ? REUNION_PHONE : AGENCY_PHONE
}

function isReunionTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone === 'Indian/Reunion'
  } catch {
    return false
  }
}
